import { ListIcon } from '../../../icons';
import { formatCalendarDate, toCurrency } from '../../../utils/formatting';
import SlideoutMenu from '../../base/SlideoutMenu';
import Entity from '../../entity';

import type { EntityAvatarFragment } from '../../entity/EntityAvatar/__generated__/EntityAvatar.gql';
import type { CalendarDate } from '@internationalized/date';

interface ILastPaymentRowProps {
  lastTransaction:
    | {
        id: string;
        date: CalendarDate;
        amount: string;
        financialAccount: EntityAvatarFragment;
      }
    | null
    | undefined;
  /** When provided, hides the row if the last transaction is the current one. */
  excludeTransactionId?: string;
  /** Called with the last transaction's ID when the row is clicked. */
  onClick: (transactionId: string) => void;
}

const LastPaymentRow = ({ lastTransaction, excludeTransactionId, onClick }: ILastPaymentRowProps) => {
  if (!lastTransaction) {
    return null;
  }

  if (excludeTransactionId && lastTransaction.id === excludeTransactionId) {
    return null;
  }

  return (
    <SlideoutMenu.Row
      icon={<ListIcon className="size-4.5 shrink-0" />}
      title="Last payment"
      onClick={() => onClick(lastTransaction.id)}
    >
      <div className="text-primary text-md flex min-w-0 items-center gap-2 font-medium">
        <Entity.Avatar entity={lastTransaction.financialAccount} size="xs" />
        {formatCalendarDate(lastTransaction.date, 'medium')}
        <span>•</span>
        {toCurrency(Number(lastTransaction.amount))}
      </div>
    </SlideoutMenu.Row>
  );
};

export default LastPaymentRow;
